import type { TenantPluginRegister } from '@yeshuman/sdk'
import { CallBookedBadge, CallBookingPanel } from './components/call-booking-panel'
import { LiveBoardSimActions } from './components/live-board-sim-header-actions'
import { petsSubtitle } from './components/pets-subtitle'
import { CallOperatorDashboard } from './dashboards'
import { CallOperatorRoutes } from './routes/operator-routes'

export const registerCalls: TenantPluginRegister = (app) => {
  app.focus.register({
    focus: 'operator',
    path: '/calls',
    home: CallOperatorDashboard,
    tree: CallOperatorRoutes,
  })
  app.nav.add('operator', [
    { path: '/calls', icon: 'Home', exact: true, label: 'Home' },
    { path: '/calls/records', icon: 'Radio' },
    { path: '/calls/evaluations', icon: 'Activity' },
    { path: '/calls/outcomes', icon: 'CalendarCheck' },
  ])
  app.calls.rowSubtitle(petsSubtitle)
  app.calls.recordBadge(CallBookedBadge)
  app.calls.recordPanel(CallBookingPanel)
  app.calls.boardActions(LiveBoardSimActions)
}
